import React, {Component} from 'react';
import {Flex, Tabs, Badge, ListView, WingBlank,Button, Toast, Modal} from 'antd-mobile';
import ReactDOM from 'react-dom';
import {withRouter} from "react-router-dom";


import {inject, observer} from 'mobx-react';
import Config from "../../config";
import WxApi from '../../common/wxapi';
import ic_invite_data from "../../res/img/ic_detail_list_data.png";


@inject("enrollStore", "loadingStore","myEnrollStore")
@observer
class UserList extends Component {
	state = {
		team:0,//模板号，1已开团  2单独购买
	}
    constructor(props) {
        super(props);
    }


    componentDidMount() {
        let {getTeamList} = this.props.enrollStore;
        getTeamList.bind(this.props.enrollStore)(this.props.eid);
    }

    // 管理工具栏：对齐小程序 groupbuy/detail.wxml enroll-sort-find-box（is_owner || admins_node.length || showDev）
    // admins_node 为当前用户角色编号数组；showDev 取详情接口 sup_vip：sup_vip=1 有权限，其它值无权限
    hasSupVipPermission(detail) {
        return detail.sup_vip === 1 || detail.sup_vip === '1';
    }

    canShowAdminTools(detail) {
        return Number(detail.is_owner) === 1
            || (Array.isArray(detail.admins_node) && detail.admins_node.length > 0)
            || this.hasSupVipPermission(detail);
    }

    // 发通知展示条件对齐小程序 enroll.sup_vip || enroll.is_owner || enroll.has_admin_3（admins_node 含 3）
    canShowNotice(detail) {
        const hasAdmin3 = Array.isArray(detail.admins_node) && detail.admins_node.some((item) => Number(item) === 3);
        return this.hasSupVipPermission(detail) || Number(detail.is_owner) === 1 || hasAdmin3;
    }

    goToolPage(path) {
        if (!Config.TOKEN) {
            React.$wx.webLogin();
            return;
        }
        if (this.props.history) {
            this.props.history.push(path);
        }
    }

    renderAdminTools(detail) {
        if (!detail || !detail.eid || !this.canShowAdminTools(detail)) {
            return null;
        }
        const eid = encodeURIComponent(detail.eid);
        return (
            <div className='admin-tools-bar'>
                <div className='admin-tool-item' onClick={() => {
                    this.goToolPage('/inviteData?eid=' + eid);
                }}>
                    <img src={ic_invite_data} />
                    <label>邀请统计</label>
                </div>
                <div className='admin-tool-item' onClick={() => {
                    this.goToolPage('/searchuser?eid=' + eid);
                }}>
                    <img src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2025-07-01/c19f83ebb5614f73f9ff1c5590af81f9.png" />
                    <label>查找</label>
                </div>
                <div className='admin-tool-item' onClick={() => {
                    // 核销签到页依赖 is_owner/auth/rank/temp 控制能力；团购活动 temp 固定 6（对齐 group/index.js toCheckin）
                    this.goToolPage('/checkin?eid=' + eid
                        + '&is_owner=' + (Number(detail.is_owner) === 1 || (detail.admins_node && detail.admins_node.length > 0) ? 1 : 0)
                        + '&auth=' + (detail.auth || 0)
                        + '&rank=' + (detail.rank_switch || 0)
                        + '&temp=6');
                }}>
                    <img src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20231023/a5173f50ae8147f4d13b05b50546569b.png" />
                    <label>核销签到</label>
                </div>
                {
                    this.canShowNotice(detail) ?
                        <div className='admin-tool-item' onClick={() => {
                            this.goToolPage('/notice?eid=' + eid);
                        }}>
                            <img src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2026-03-17/2e1868c8ac1ab7af0d7bb569ffbb00f2.png" />
                            <label>发通知</label>
                        </div> : null
                }
            </div>
        );
    }

    render() {
        let {userDataSource, getTeamList, userListLoading, userListNumCount,singleListNumCount, isEnd, currentTab} = this.props.enrollStore;
        let {detail} = this.props.enrollStore;
        const row = (rowData, sectionID, rowID) => {
            let getStatue = () => {
				
				if(rowData.fail){
					return (
					    <div className={"Detail-item-des1 "}>
					        拼团失败(已退款)
					    </div>
					)
				}else{
				// 待支付状态优先展示，避免已成团时被误显示为购买成功。
				if (rowData.pay_status == 0) {
					return (
						<div className={"Detail-item-des1 pending-pay"}>
							待支付
						</div>
					)
				}
				
                if (rowData.team_num == rowData.joins) {
                	if(currentTab ==1){
                		return (
	                        <div className={"Detail-item-des1 "}>
	                        	 购买成功
	                        </div>
	                    )
                	}else{
                		return (
	                        <div className={"Detail-item-des1 "}>
	                        	 拼团成功
	                        </div>
	                    )
                	}
                    
                }
                else if (detail.status == 2 || isEnd) {
                    return (
                        <div className={"Detail-item-des1 "}>
                            拼团失败
                        </div>
                    )
                }
                else if (rowData.team_num > rowData.joins ) {
                	if(rowData.has_join){
                		 return (
	                        <div className={"group-info"} >
	                            <span>还差  <span className={"people-num"}>{rowData.team_num - rowData.joins}</span> 人成团</span>
                                {
                                    <Button inline className='team-btn join-btn' onClick={(e)=>{
                                        e.stopPropagation();
                                        const parm = {                                            
                                            tid: rowData.tid,
                                            type: 5,
                                        }                                        
                                        this.props.myEnrollStore.toShareGroup(parm).then(res=>{
                                            if(res.sta == 0){
                                                React.$wx.previewImage({
                                                    current: res.data.url, // 当前显示图片的http链接
                                                    urls: [res.data.url] // 需要预览的图片http链接列表
                                                })                                                
                                            }else{
                                                Toast.fail(res.msg);
                                            }
                                        })
                                    }}>邀请团</Button>                                    
                                }	                           
	                        </div>
	                    )
                	}else{
                		 return (
	                        <div className={"group-info"}>
	                            <span>还差 <span className={"people-num"}>{rowData.team_num - rowData.joins}</span> 人成团</span>
	                            <Button inline  className={"team-btn join-btn"} onClick={()=>{
                                    if(Config.TOKEN){
                                        this.props.enrollStore.getItemData().then(()=>{
                                            this.props.enrollStore.setTeamId(rowData.tid)
                                            this.props.history.push('/enrollGroupForm')
                                        })                                       
                                    }else{
                                        React.$wx.webLogin()
                                    }
	                            	
	                            }}>去参团</Button>
	                        </div>
	                    )
                	}
                }
                else if (currentTab == 2) {
                    return (
                        <div className={"Detail-item-des1 gray"}>
                            右箭头
                        </div>
                    )
                }
				
				}
				
            };
            let getName = function () {
                if(detail.user_visible == 1  ){
                	if(currentTab ==1){
                		 return (<div className="Detail-item-name">
                                { WxApi.getDefaultName(rowData.names[0]) }
                            </div>)
                	}
                   
                }
                else{
                    return (<div className="Detail-item-name">**</div>)
                }
            };
             
            if(rowData.team_num == rowData.joins && rowData.heads && rowData.heads.length != rowData.team_num){
                for(let a = 0;a<rowData.team_num;a++){
                    if(!rowData.heads[a]){
                        rowData.heads.push(Config.defaultAvatar)
                    }
                }
            }
            return (
                <Flex key={rowID} className="Detail-list-item" onClick={()=>{
                    if(rowData.has_join){
                        this.props.enrollStore.setTeamId(rowData.tid)
                        this.props.myEnrollStore.setCurrentEnroll({info_id: rowData.info_id})                                 
                        // 单购待支付记录需先完成支付，避免进入未完成的报名详情页。
                        if(currentTab == 1 && rowData.pay_status == 0){
                            Modal.alert('温馨提示', '支付成功后即可查看完整报名详情', [{ text: '我知道了' }]);
                            return;
                        }
                        this.props.history.push('/groupCert')
                    }                    
                }}>
                    {
                    	rowData.heads && rowData.heads.length ? rowData.heads.map(function(item,index){
                    		if(index <5){
                    			return (<img className="header-img" src={item}/>)
                    		}
                    		
                    	}):<img className="header-img" src={Config.defaultAvatar}/>
                    }
                    <div className="Detail-list-flexpanel">
                    	{
                    		getName()
                    	}
                    </div>
                       
                        <Flex.Item className="Detail-item-des"  >
                            {
                                getStatue()
                            }
                        </Flex.Item>
                </Flex>
            );
        };
        
        const tabs = [
            {title: <Badge>已开团({userListNumCount})</Badge>},
            {title: <Badge>单独购买({singleListNumCount})</Badge>},
        ];
        
        return (

            <Flex className='group-user-list'>
                <Tabs tabs={tabs} tabBarActiveTextColor={this.props.themColor} tabBarUnderlineStyle={{backgroundColor: this.props.themColor, height: '2px', 'border': 0}}
                      swipeable={false}
                      initialPage={0}                      
                      onTabClick={(tab, index) => {
                            var team = index ? 2 : 1;
                            var enrollStore = this.props.enrollStore;
                            enrollStore.setCurrentTab(index)
                            enrollStore.setTeam(team);
                            enrollStore.getTeamList();                                                    
                      }}
                >
                <div>
                    {this.renderAdminTools(detail)}
                    <div className='msg-notification' onClick={()=>{
                        if(detail.is_fans){				
                            this.props.openMsg()        
                        }else{
                            window.location.href = 'https://mp.weixin.qq.com/s/7xoT8N4jJuR36X3UoZEQVg'
                        }               
                    }}>
                        <i className='notify-img iconfont icon-svg45-copy' style={{color: this.props.themColor}}></i>
                        <h2 className='notify-title'>订阅通知 <span className='notify-desc'>及时接收报名成功、取消等</span></h2>                   
                        <span className='notify-btn' style={{color: this.props.themColor}}>去订阅 ></span>
                    </div>
                    {
                        userListNumCount != 0 ? <ListView
                        	className="Detail-content-member"
                            ref={el => this.lv = el}
                            dataSource={userDataSource}
                            renderFooter={() => (<div style={{textAlign: 'center'}}>
                                {userListLoading ? '正在加载...' : ''}
                            </div>)}
                            renderRow={row}
                            useBodyScroll={true}
                            scrollRenderAheadDistance={100}
                            onEndReached={() => getTeamList.bind(this.props.enrollStore)(this.props.eid)}

                        /> : <div className={`placeholder`}>还没有人参与</div>
                    }
                </div>   
                <div>
                    {this.renderAdminTools(detail)}
                    <div className='msg-notification' onClick={()=>{
                        this.props.openMsg()
                    }}>
                       <i className='notify-img iconfont icon-svg45-copy' style={{color: this.props.themColor}}></i>
                        <h2 className='notify-title'>订阅通知 <span className='notify-desc'>及时接收报名成功、取消等</span></h2>                   
                        <span className='notify-btn' style={{color: this.props.themColor}}>去订阅 ></span>
                    </div>
                    {
                        singleListNumCount != 0 ? <ListView
                            className="Detail-content-member"
                            ref={el => this.lv = el}
                            dataSource={userDataSource}
                            renderFooter={() => (<div style={{textAlign: 'center'}}>
                                {userListLoading ? '正在加载...' : ''}
                            </div>)}
                            renderRow={row}
                            useBodyScroll={true}
                            scrollRenderAheadDistance={100}
                            onEndReached={() => getTeamList.bind(this.props.enrollStore)(this.props.eid)}

                        /> : <div className={`placeholder`}>还没有人参与</div>
                    } 
                </div>                                 
                </Tabs>
            </Flex>
        )
        
        
        
    }
}

export default withRouter(UserList);
